export const CARD_CLASS =
  "rounded-3xl border border-white/70 bg-white/90 p-6 shadow-[0_18px_40px_rgba(15,23,42,0.08)] backdrop-blur";

export const KPI_CARD_CLASS =
  "rounded-3xl border border-white/70 bg-white/90 p-5 shadow-[0_10px_30px_rgba(15,23,42,0.08)] backdrop-blur";

export const FILTER_SELECT_CLASS = "bg-slate-50/80 border-slate-200/80 shadow-inner";

export const KPI_ACCENTS = {
  emerald: {
    gradient: "from-emerald-500/70 via-emerald-400/40 to-emerald-200/10",
    dot: "bg-emerald-500",
  },
  indigo: {
    gradient: "from-indigo-500/70 via-indigo-400/40 to-indigo-200/10",
    dot: "bg-indigo-500",
  },
  violet: {
    gradient: "from-violet-500/70 via-violet-400/40 to-violet-200/10",
    dot: "bg-violet-500",
  },
  amber: {
    gradient: "from-amber-500/70 via-amber-400/40 to-amber-200/10",
    dot: "bg-amber-500",
  },
  slate: {
    gradient: "from-slate-500/60 via-slate-400/40 to-slate-200/10",
    dot: "bg-slate-500",
  },
} as const;

export type KpiAccent = keyof typeof KPI_ACCENTS;

export const TABLE_ACCENTS = {
  violet: {
    line: "bg-violet-500",
    pill: "border-violet-100 bg-violet-50 text-violet-700",
  },
  emerald: {
    line: "bg-emerald-500",
    pill: "border-emerald-100 bg-emerald-50 text-emerald-700",
  },
} as const;

export type TableAccent = keyof typeof TABLE_ACCENTS;

export const DATA_GRID_SX = {
  border: "1px solid #e2e8f0",
  borderRadius: 0,
  overflow: "hidden",
  backgroundColor: "#ffffff",
  fontFamily: "inherit",
  "& .MuiDataGrid-main": {
    borderRadius: 0,
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#f1f5f9",
    borderBottom: "1px solid #e2e8f0",
    fontWeight: 700,
    fontSize: "0.72rem",
    textTransform: "uppercase",
    color: "#94a3b8",
  },
  "& .MuiDataGrid-columnHeaderTitleContainer": {
    justifyContent: "center",
  },
  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-columnSeparator": { display: "none" },
  "& .MuiDataGrid-row": {
    borderBottom: "1px solid #f1f5f9",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #f1f5f9",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 6px",
    fontSize: "0.9rem",
    color: "#0f172a",
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "#f8fafc",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "#f8fafc",
    minHeight: 52,
  },
};
